import { createFetch } from "../../../../../helpers/fetch/FetchRequest";
import { getCookie } from "../../../../../helpers/common";
import { API_BUILDER_PROJECTS_GET_NODE } from "../../../../../settings/endpoints/stacker";
import { USER_ACCESS_TOKEN_NAME } from "../../../../../settings/global";

export function getProjects({
                                setProjects,
                                setProjectsStatus,
                                onSuccess,
                            }) {

    setProjectsStatus('loading');
    createFetch({
        // URL: `${API_BUILDER_PROJECTS_GET_NODE}?user=${store.getState().userData?.user?._id}`,
        URL: `${API_BUILDER_PROJECTS_GET_NODE}`,
        headers: {'Authorization': 'Bearer ' + getCookie(USER_ACCESS_TOKEN_NAME)},
        onSuccess: res => {
            const sorted = res.list.sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at))
            setProjects(sorted);
            setProjectsStatus('success');
            if (onSuccess) onSuccess(sorted);
        },
        onError: res => {
            setProjectsStatus('error');
        },
    })
}